const AUTH = {
  authenticate: 'auth/authenticate',
  refresh: 'auth/refresh',
  refreshWorkspaceToken: 'auth/refresh-workspace-token',
  logout: 'auth/logout',
  workspace: 'auth/workspace',
  google: 'auth/google',
  desktopSignin: 'auth/desktop-signin',
  samlLogin: (workspaceId) => `auth/saml/login/${workspaceId}`,
  samlCallback: (workspaceId) => `auth/saml/callback/${workspaceId}`,
  samlMetadata: (workspaceId) => `auth/saml/metadata/${workspaceId}`,
  samlLogout: (workspaceId) => `auth/saml/logout/${workspaceId}`,
};

const USER = {
  signup: 'user',
  account: 'user/account',
  workspaces: 'user/workspaces',
  workspacesForSuperAdmin: 'user/workspaces-for-superadmin',
  resetPassword: 'user/reset-password',
  changePassword: 'user/change-password',
  updateAddress: 'user/location',
  getpasswordupdateat: 'user/password-update-at',
  users: () => 'user/users',
  faceRegister: 'face-recognition/register',
  faceRegisterRequest: 'face-recognition/request-new',
  updateAddressRequest: 'user/update-address-request',
  fetchFaceIdData: 'face-recognition/userData',
  fetchMemberFaceIdData: (memberId) => `face-recognition/userData/${memberId}`,
  fetchProfileRequest: (memberId) => `face-recognition/profile-update-requests/${memberId}`,
  fetchPendingFaceIdUpdateRequest: (memberId) => `face-recognition/pending-faceId-request/${memberId}`,
};

const ORGANIZATION = {
  create: 'organization',
  organizations: () => 'organization/organizations',
  filterOrganizationAll: () => 'organization/filterOrganizationAll',
  getStorageSettings: (organizationId) => `organization/${organizationId}/storage-settings`,
  updateStorageSettings: (organizationId) => `organization/${organizationId}/storage-settings`,
};

const TWO_FACTOR = {
  verify: 'twofactor/verify',
  renew: 'twofactor/renew',
};

const WORKSPACE_HOLIDAY = {
  offTimeHolidays: (workspaceId) => `workspace/${workspaceId}/offTimeHolidays`,
  createHoliday: (workspaceId) => `workspace/${workspaceId}/offTimeHoliday`,
  deleteHoliday: (workspaceId, holidayId) => `workspace/${workspaceId}/offTimeHoliday/${holidayId}`,
  editHoliday: (workspaceId, holidayId) => `workspace/${workspaceId}/offTimeHoliday/${holidayId}`,
};

const WORKSPACE = {
  create: 'workspace',
  workspaceUpdateWebcamAuditsPerPeriod: (workspaceId) => `workspace/${workspaceId}/webcamAuditsPerPeriod`,
  workspaceUpdateScreenshotsPerPeriod: (workspaceId) => `workspace/${workspaceId}/screenshotsPerPeriod`,
  workspaceWebcamAudits: (workspaceId) => `workspace/${workspaceId}/webcamAudits`,
  workspaceWebcamViolations: (workspaceId) => `workspace/${workspaceId}/webcamViolations`,
  workspaceLocationViolations: (workspaceId) => `workspace/${workspaceId}/locationViolations`,
  workspaceUpdateBlurScreenshots: (workspaceId) => `workspace/${workspaceId}/blurScreenshots`,
  members: (workspaceId) => `workspace/${workspaceId}/members`,
  geoMapMembers: (workspaceId) => `workspace/${workspaceId}/geo-map-members`,
  reportingManagers: (workspaceId) => `workspace/${workspaceId}/reportingManagers`,
  webcamAuditLatest: (workspaceId) => `workspace/${workspaceId}/members/webcam/latest`,
  membersActivity: (workspaceId) => `workspace/${workspaceId}/members/activity`,
  membersActivityExport: (workspaceId) => `workspace/${workspaceId}/members/activity/export`,
  membersDailyActivity: (workspaceId) => `workspace/${workspaceId}/members/daily-activity`,
  membersGeolocations: (workspaceId) => `workspace/${workspaceId}/members/geolocations`,
  membersBalances: (workspaceId) => `workspace/${workspaceId}/members/balances`,
  membersCount: (workspaceId) => `workspace/${workspaceId}/members/count`,
  editMembersBalances: (workspaceId) => `workspace/${workspaceId}/members/balances`,
  member: (workspaceId) => `workspace/${workspaceId}/member`,
  editMember: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}`,
  getMember: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}`,
  manualActivityEntry: (memberId) => `member/${memberId}/manual-activity`,
  deleteMember: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}`,
  deactivateMember: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/deactivate`,
  memberUpdateAccountType: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/accountType`,
  memberUpdateWebcamAuditsPerPeriod: (workspaceId, memberId) => `workspace/${workspaceId}/member/
    ${memberId}/webcamAuditsPerPeriod`,
  memberUpdateScreenshotsPerPeriod: (workspaceId, memberId) => `workspace/${workspaceId}/member/
    ${memberId}/screenshotsPerPeriod`,
  memberUpdateBlurScreenshots: (workspaceId, memberId) => `workspace/${workspaceId}/member/
    ${memberId}/blurScreenshots`,
  memberToggleIdleTimeTracking:
    (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/idle-time-tracking`,
  memberToggleManualTracker:
    (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/manual-tracker`,
  createTeam: (workspaceId) => `workspace/${workspaceId}/team`,
  getAllTeams: () => 'workspace/teams',
  getAllTeamInfo: (workspaceId) => `workspace/${workspaceId}/teamsInfo`,
  filterTeamAll: () => 'workspace/filterTeamAll',
  getAllUsers: () => 'workspace/members/users',
  getAllWorkspaces: () => 'workspace/workspaces',
  filterWorkspaceAll: () => 'workspace/filterWrokspaceAll',
  deleteTeam: (workspaceId, teamId) => `workspace/${workspaceId}/team/${teamId}`,
  updateTeam: (workspaceId, teamId) => `workspace/${workspaceId}/team/${teamId}`,
  getTeams: (workspaceId) => `workspace/${workspaceId}/teams`,
  resolveLocationViolation: (workspaceId) => `workspace/${workspaceId}/locationViolation/resolve`,
  membersInsiderThreats: (workspaceId) => `workspace/${workspaceId}/insiderThreats`,
  resolveMemberThreats: (workspaceId, memberId) => `workspace/${workspaceId}/members/
    ${memberId}/insiderThreats/resolve`,
  memberInsiderThreats: (workspaceId, memberId) => `workspace/${workspaceId}/members/${memberId}/insiderThreats`,
  resolveThreat: (violationId) => `workspace/insiderThreats/${violationId}/resolve`,
  resendInvitation: (workspaceId, userId) => `workspace/${workspaceId}/user/${userId}/resend-invitation`,
  getTeam: (workspaceId, teamId) => `workspace/${workspaceId}/team/${teamId}`,
  getWorkspacePicture: (workspaceId) => `workspace/${workspaceId}/picture`,
  updateWorkspacePicture: (workspaceId) => `workspace/${workspaceId}/picture`,
  removeWorkspacePicture: (workspaceId) => `workspace/${workspaceId}/picture`,
  authentication: (workspaceId) => `workspace/${workspaceId}/authentication`,
  offTimePolicies: (workspaceId) => `workspace/${workspaceId}/offTimePolicies`,
  editOffTimeBalance: (workspaceId) => `workspace/${workspaceId}/offTimeBalance`,
  createTimeOffPolicy: (workspaceId) => `workspace/${workspaceId}/offTimePolicy`,
  deleteOffTimePolicy: (workspaceId, offTimePolicyId) => (
    `workspace/${workspaceId}/offTimePolicy/${offTimePolicyId}`
  ),
  archiveOffTimePolicy: (workspaceId, offTimePolicyId) => (
    `workspace/${workspaceId}/offTimePolicy/${offTimePolicyId}/archive`
  ),
  restoreOffTimePolicy: (workspaceId, offTimePolicyId) => (
    `workspace/${workspaceId}/offTimePolicy/${offTimePolicyId}/restore`
  ),
  updateOffTimePolicy: (workspaceId, offTimePolicyId) => (
    `workspace/${workspaceId}/offTimePolicy/${offTimePolicyId}`
  ),
  getOffTimeData: (workspaceId, memberId) => `workspace/${workspaceId}/offTimeData/${memberId}`,
  getPTOBalances: (workspaceId, memberId) => `/workspace/${workspaceId}/member/${memberId}/pto-balances`,
  getTeamOffTimeData: (workspaceId) => `workspace/${workspaceId}/teamOffTimeData`,
  createOffTimeRequest: (workspaceId, memberId) => `workspace/${workspaceId}/createOffTimeRequest/${memberId}`,
  editOffTimeRequest: (workspaceId, requestId) => `workspace/${workspaceId}/editOffTimeRequest/${requestId}`,
  deleteOffTimeRequest: (workspaceId, requestId) => `workspace/${workspaceId}/deleteOffTimeRequest/${requestId}`,
  approveOffTimeRequest: (workspaceId, offTimeRequestId) => (
    `workspace/${workspaceId}/offTimeRequest/${offTimeRequestId}/approve`
  ),
  updateGlobalSettings: (workspaceId) => `workspace/${workspaceId}/globalsettings`,
  getGlobalSettings: (workspaceId) => `workspace/${workspaceId}/globalsettings`,
  getTeamVisibilityControls: (workspaceId, teamId) => `workspace/${workspaceId}/teamVisibilityControls/${teamId}`,
  updateTeamVisibilityControls: (workspaceId) => `workspace/${workspaceId}/teamVisibilityControls`,
  setTeamVisibilityControls: (workspaceId) => `workspace/${workspaceId}/teamVisibilityControls`,
  deleteTeamVisibilityControls: (workspaceId) => `workspace/${workspaceId}/teamVisibilityControls`,
  getProductivityEmailSettings: (workspaceId) => `workspace/${workspaceId}/productivityEmailSettings`,
  setProductivityEmailSettings: (workspaceId) => `workspace/${workspaceId}/productivityEmailSettings`,
  updateProductivityEmailSettings: (workspaceId) => `workspace/${workspaceId}/productivityEmailSettings`,
  deleteProductivityEmailSettings: (workspaceId) => `workspace/${workspaceId}/productivityEmailSettings`,
  getAllTeamMates: () => 'workspace/teammates',
  getAlertOfMember: (workspaceId) => `workspace/${workspaceId}/alertOfMember`,
  getAlertTypes: () => 'workspace/alertTypes',
  denyOffTimeRequest: (workspaceId, offTimeRequestId) => (
    `workspace/${workspaceId}/offTimeRequest/${offTimeRequestId}/deny`
  ),
  designations: (workspaceId) => (
    `workspace/${workspaceId}/designations`
  ),
  designation: (workspaceId) => (
    `workspace/${workspaceId}/designation`
  ),
  deleteDesignation: (workspaceId, designationId) => (
    `workspace/${workspaceId}/designation/${designationId}`
  ),
  departments: (workspaceId) => (
    `workspace/${workspaceId}/departments`
  ),
  department: (workspaceId) => (
    `workspace/${workspaceId}/department`
  ),
  deleteDepartment: (workspaceId, departmentId) => (
    `workspace/${workspaceId}/department/${departmentId}`
  ),
  getWorkBreaks: (workspaceId) => `workspace/${workspaceId}/workBreaks`,
  archiveWorkBreakPolicy: (workspaceId, workBreakPolicyId) => (
    `workspace/${workspaceId}/workBreakPolicy/${workBreakPolicyId}/archive`
  ),
  restoreWorkBreakPolicy: (workspaceId, workBreakPolicyId) => (
    `workspace/${workspaceId}/workBreakPolicy/${workBreakPolicyId}/restore`
  ),
  deleteWorkBreakPolicy: (workspaceId, workBreakPolicyId) => (
    `workspace/${workspaceId}/workBreakPolicy/${workBreakPolicyId}`
  ),
  createWorkBreaks: (workspaceId) => `workspace/${workspaceId}/workBreaks`,
  updateWorkBreaks: (workspaceId, workBreakPolicyId) => `workspace/${workspaceId}/workBreaks/${workBreakPolicyId}`,
  updateMembership: (workspaceId) => `workspace/${workspaceId}/subscription/membership`,
  getInvoices: (workspaceId) => `workspace/${workspaceId}/subscription/invoices`,
  subscription: (workspaceId) => `workspace/${workspaceId}/subscription`,
  getTransactions: (workspaceId) => `workspace/${workspaceId}/subscription/transactions`,
  getPlanExpiry: (workspaceId) => `workspace/${workspaceId}/subscription/plan-expiry`,
  getActiveSubscription: (workspaceId) => `workspace/${workspaceId}/subscription/active`,
  getUpcomingSubscriptions: (workspaceId) => `workspace/${workspaceId}/subscription/upcoming`,
  getSubscriptionSettings: (workspaceId) => `workspace/${workspaceId}/subscription/settings`,
  updateAutoRenewal: (workspaceId) => `workspace/${workspaceId}/subscription/auto-renewal`,
  // eslint-disable-next-line max-len
  downloadInvoice: (workspaceId, transactionId) => `workspace/${workspaceId}/subscription/transactions/${transactionId}/invoice`,
  // eslint-disable-next-line max-len
  updateTransactionStatus: (workspaceId, transactionId) => `workspace/${workspaceId}/subscription/transactions/${transactionId}/status`,
  ...WORKSPACE_HOLIDAY,
  membersWorkingHours: (workspaceId) => `workspace/${workspaceId}/members/workingHours`,
  updateWorkingHours: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/workingHours`,
  updateWorkspaceWorkingHours: (workspaceId) => `workspace/${workspaceId}/workingHours`,
  memberships: () => 'membership',
  membership: (id) => `membership/${id}`,
  billingAddress: (workspaceId) => `workspace/${workspaceId}/billingAddress`,
  memberChanges: (workspaceId) => `workspace/${workspaceId}/memberChanges`,
  // allMembers: (workspaceId) => `workspace/${workspaceId}/members/all`,
  dashboardMembers: (workspaceId) => `dashboard/${workspaceId}/members`,
  organizationChart: (workspaceId) => `workspace/${workspaceId}/organizationChart`,
  dashboardAlerts: (workspaceId) => `dashboard/${workspaceId}/alerts`,
  getAlerts: (workspaceId) => `workspace/${workspaceId}/alerts`,
  getPendingAlertsCount: (workspaceId) => `workspace/${workspaceId}/alerts/pending-counts`,
  getAlertByToken: (workspaceId, token) => `workspace/${workspaceId}/alertByToken/${token}`,
  getTeamPerformance: (workspaceId) => `workspace/${workspaceId}/teamPerformance`,
  acknowledgedByManager: (alertId) => `workspace/alerts/${alertId}/acknowledgedByManager`,
  getAcknowledgement: () => 'workspace/alerts/acknowledgements',
  sendAcknowledgement: (alertId) => `workspace/alerts/${alertId}/sendAcknowledgement`,
  submitAcknowledgementResponse:
      (workspaceId, alertId) => `workspace/${workspaceId}/submitAcknowledgementResponse/${alertId}`,
  teamManagementMembers: (workspaceId) => `workspace/${workspaceId}/teamManagement/members`,
  memberManagement: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/management`,
  getProfileUpdateRequests: (workspaceId) => `workspace/${workspaceId}/profileUpdateRequests`,
  profileUpdateApprovalByManager:
      (profileRequestId) => `workspace/profileUpdateApprovalByManager/${profileRequestId}`,
  memberDailyActivity: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/daily-activity`,
  setupAlert: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/setup-alert`,

  getProjects: (workspaceId) => `workspace/${workspaceId}/projects`,
  createProject: (workspaceId) => `workspace/${workspaceId}/projects`,
  updateProject: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}`,
  deleteProject: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}`,

  getProjectMembers: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}/members`,
  // updateProjectMembers: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}/members`,
  getWorkspaceMembers: (workspaceId) => `workspace/${workspaceId}/members/dropdown`,
  addProjectMembers: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}/members`,

  getProjectTeams: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}/teams`,
  updateProjectTeams: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}/teams`,
  getWorkspaceTeams: (workspaceId) => `workspace/${workspaceId}/teams/dropdown`,
  addProjectTeams: (workspaceId, projectId) => `workspace/${workspaceId}/projects/${projectId}/teams`,

  memberProjectCounts: (workspaceId) => `workspace/${workspaceId}/members/project-counts`,
  addToProjects: (workspaceId, memberId) => `workspace/${workspaceId}/members/${memberId}/projects`,
  getMemberProjects: (workspaceId, memberId) => `workspace/${workspaceId}/members/${memberId}/projects`,
  updateMemberProjects: (workspaceId, memberId) => `/workspace/${workspaceId}/member/${memberId}/projects`,
  features: (workspaceId) => `workspace/${workspaceId}/features`,
};

const MEMBER = {
  activity: (memberId) => `member/${memberId}/activity`,
  deleteActivity: (memberId, activityId) => `member/${memberId}/activity/${activityId}`,
  lastActivity: (memberId) => `member/${memberId}/lastActivity`,
  activityList: (memberId) => `member/${memberId}/activity-list`,
  screenshot: (memberId) => `member/${memberId}/file/screenshot`,
  fileUrl: (memberId) => `member/${memberId}/file/url`,
  webcamAudit: (memberId) => `member/${memberId}/webcamAudit`,
  webcamAudits: (memberId) => `member/${memberId}/webcamAudits`,
  webcamViolations: (memberId) => `member/${memberId}/webcamViolations`,
  locationViolations: (memberId) => `member/${memberId}/locationViolations`,
  activityLogs: () => 'member/activity-logs',
};

const TEAM = {
  create: 'team',
  emailSchedule: (teamId) => `team/${teamId}/emailSchedule`,
};

const ROLES = {
  getRoles: (workspaceId) => `workspace/${workspaceId}/roles`,
  getRole: (workspaceId, roleId) => `workspace/${workspaceId}/role/${roleId}`,
  createRole: (workspaceId) => `workspace/${workspaceId}/role`,
  updateRole: (workspaceId, roleId) => `workspace/${workspaceId}/role/${roleId}`,
  deleteRole: (workspaceId, roleId) => `workspace/${workspaceId}/role/${roleId}`,
  getPermissions: (workspaceId) => `workspace/${workspaceId}/permissions`,
  getPermissionsByResource: (workspaceId, resource) => `workspace/${workspaceId}/permissions/resource/${resource}`,
  assignPermissions: (workspaceId, roleId) => `workspace/${workspaceId}/role/${roleId}/permissions`,
  getMemberPermissions: (workspaceId, memberId) => `workspace/${workspaceId}/member/${memberId}/permissions`,
};

const UNUSUAL_ACTIVITY = {
  getWorkspaceSummary: (workspaceId) => `unusual-activity/workspace/${workspaceId}/summary`,
  getMemberDetails: (memberId) => `unusual-activity/member/${memberId}`,
  getMemberEvidence: (memberId) => `unusual-activity/member/${memberId}/evidence`,
  exportPDF: () => 'unusual-activity/export/pdf',
};

const base = (workspaceId) => `workspace/${workspaceId}/chart-abstraction`;
const CHART_ABSTRACTION = {
  // nav gating (any member)
  status: (workspaceId) => `${base(workspaceId)}/status`,
  // settings (admin)
  settings: (workspaceId) => `${base(workspaceId)}/settings`,
  access: (workspaceId, memberId) => `${base(workspaceId)}/access/${memberId}`,
  // rep timer
  myCharts: (workspaceId) => `${base(workspaceId)}/my-charts`,
  startChart: (workspaceId) => `${base(workspaceId)}/charts`,
  complete: (workspaceId, chartId) => `${base(workspaceId)}/charts/${chartId}/complete`,
  pend: (workspaceId, chartId) => `${base(workspaceId)}/charts/${chartId}/pend`,
  restart: (workspaceId, chartId) => `${base(workspaceId)}/charts/${chartId}/restart`,
  reviewAgain: (workspaceId, chartId) => `${base(workspaceId)}/charts/${chartId}/review-again`,
  // qa queue
  qaQueue: (workspaceId) => `${base(workspaceId)}/qa-queue`,
  qaComplete: (workspaceId, chartId) => `${base(workspaceId)}/charts/${chartId}/qa-complete`,
  qaDeny: (workspaceId, chartId) => `${base(workspaceId)}/charts/${chartId}/qa-deny`,
  // admin monitoring
  adminOverview: (workspaceId) => `${base(workspaceId)}/admin/overview`,
  productivity: (workspaceId, from, to) => {
    const qs = from || to ? `?from=${from || ''}&to=${to || ''}` : '';
    return `${base(workspaceId)}/admin/productivity${qs}`;
  },
};

const API = {
  AUTH,
  USER,
  ORGANIZATION,
  TWO_FACTOR,
  WORKSPACE,
  MEMBER,
  TEAM,
  ROLES,
  UNUSUAL_ACTIVITY,
  CHART_ABSTRACTION,
};

export default API;
